import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SaidaEstoqueRoutingModule } from './saida-estoque-routing.module';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    SaidaEstoqueRoutingModule
  ]
})
export class SaidaEstoqueModule { }
